module.exports = __webpack_public_path__ + "static/media/medic-cheers.0b30fab4.png";